import { Modal } from "antd";
import React from "react";

const ConfirmationModal = (props: any) => {
  return (
    <Modal
      open={props.showModal}
      onCancel={props.onCancel}
      okText="Yes"
      cancelText="Cancel"
      footer={props.footer}
      maskClosable={false}
    >
      <div className="flex flex-col gap-2 items-center">
        {props.icon}
        <span className="text-center">{props.title}</span>
        <span className="text-[13px] text-gray-600 text-center">
          {props.body}
        </span>
      </div>
      {props.content} {/* ✅ add this */}
      {props.children}
    </Modal>
  );
};

export default ConfirmationModal;